/**
 * Created by eriksundqvist on 10/05/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { Link } from 'react-router';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { CouponService } from 'frilans-finans';
import { Spinner } from 'components';
import ReadMoreModal, { EXPRESS } from '../read-more-modal/read-more-modal';

const DEFAULT_COUNTRY = 'SWEDEN';

export class Offers extends React.Component {

  static propTypes = {
    setExpressPayment: PropTypes.func.isRequired,
    expressPayment: PropTypes.bool.isRequired,
    couponId: PropTypes.string.isRequired,
    setCouponId: PropTypes.func.isRequired,
    rot: PropTypes.bool.isRequired,
    rut: PropTypes.bool.isRequired,
    customer: PropTypes.object,
    setCoupon: PropTypes.func.isRequired,
    clearCoupon: PropTypes.func.isRequired,
    invoiceId: PropTypes.string
  };

  constructor (props) {
    super(props);

    this.state = {
      checkingCoupon: false,
      couponValid: false,
      renderModal: false
    };

    this.expressPaymentClick = this.expressPaymentClick.bind(this);
    this.onChangeCouponId = this.onChangeCouponId.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.couponId !== this.props.couponId) {
      this.startRequestTimeout();
    }
  }

  componentDidUpdate () {
    if (this.cannotUseExpressPayment() && this.props.expressPayment) {
      this.props.setExpressPayment(false);
    }
  }

  expressPaymentClick (event) {
    this.props.setExpressPayment(!this.props.expressPayment);
  }

  onChangeCouponId (e) {
    this.props.setCouponId(e.target.value);
  }

  /**
   * Wait 300 ms since last input before making the request to
   * the backend.
   */
  startRequestTimeout () {
    if (this.requestTimeout) {
      window.clearTimeout(this.requestTimeout);
    }

    this.requestTimeout = setTimeout(this.checkCoupon.bind(this), 300);
  }

  checkCoupon () {
    if (this.props.couponId !== '') {
      this.setState({
        checkingCoupon: true
      });

      CouponService.getById(this.props.couponId, this.props.invoiceId)
        .then((coupon) => {
          this.setState({
            couponValid: true,
            checkingCoupon: false
          });

          this.props.setCoupon(coupon);
        })
        .catch((e) => {
          this.setState({
            couponValid: false,
            checkingCoupon: false
          });

          this.props.clearCoupon();
        });
    } else {
      this.props.clearCoupon();
    }
  }

  toggleModal (e) {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      renderModal: !this.state.renderModal
    });
  }

  renderModal () {
    if (this.state.renderModal) {
      return (
        <ReadMoreModal
          close={this.toggleModal}
          text={EXPRESS}
        />
      );
    }
  }

  renderCouponImage () {
    if (this.state.checkingCoupon) {
      return (
        <div className="coupon-image">
          <Spinner size={25}/>
        </div>
      );
    }
    if (this.props.couponId !== '') {
      if (this.state.couponValid) {
        return (<div className="coupon-image sprite-image thumbs-up"></div>);
      } else {
        return (<div className="coupon-image sprite-image thumbs-down"></div>);
      }
    }
  }

  cannotUseExpressPayment () {
    const { customer, rot, rut } = this.props;
    const country = customer && customer.address && customer.address.country;
    return rot || rut || (country !== DEFAULT_COUNTRY && country !== null);
  }

  render () {
    let validClass = '';

    if (this.props.couponId !== '') {
      validClass = this.state.couponValid ? 'valid' : 'invalid';
    }

    return (
      <div className='invoice-offers'>
        <div className='col-sm-4'>
          <p>
            <Translate content='SAME_DAY_PAYMENT'/>
            <Link to='#' activeClassName='selected' onClick={this.toggleModal}>
              <Translate content='EXPRESS_PAYMENT_READ_MORE'/>
            </Link>
          </p>
          <input id='express-betalning'
            type='checkbox'
            name='express-betalning'
            value={this.props.expressPayment}
            checked={this.props.expressPayment}
            disabled={this.cannotUseExpressPayment()}
            onClick={this.expressPaymentClick}
          />
          <label htmlFor='express-betalning'><span></span></label>
          <img src={require('images/logos/express-betalning.png')} alt='Expressbetalning' />
        </div>
        <div className='col-sm-4 coupon-wrapper'>
          <p className='black'><Translate content='CAMPAIGN_CODE_TITLE'/></p>
          <input
            type='text'
            className={validClass}
            name='kampanjkod'
            placeholder={proxyCounterpart('CAMPAIGN_CODE')}
            value={this.props.couponId}
            onChange={this.onChangeCouponId}
          />
            {this.renderCouponImage()}
        </div>
        {this.renderModal()}
      </div>
    );
  }
}

export default Offers;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/offers/offers.js
 **/